/* eslint-disable */
import { lazy } from 'react';
import { USER_ROLE } from 'constants.js';
import { DEFAULT_PATHS } from 'config.js';
import LessonParts from 'views/learning/LessonParts';
import HomeWork from 'views/utilities/homework';
import DayPlan from 'views/utilities/dayPlan';
import Alert from 'views/utilities/Alerts';
import AssessmentComponent from 'views/utilities/tables/learningResource/Assessment';
import ComingSoon from 'views/utilities/tables/comingSoon/coming_soon';
import ComingSoonModule from 'views/utilities/tables/comingSoon/ComingSoonModule';
// import AssessmentQuetions from 'views/utilities/tables/assessment/components/ViewAssessmentQuesions';

const assessmentQuestions = {
  questions: lazy(()=>import('views/utilities/tables/assessment/components/ViewAssessmentQuestions'))
}

const blog = lazy(() => import('views/blog/Blog'));
const community = {
  index: lazy(() => import('views/community/Community')),
  list: lazy(() => import('views/community/CommunityList')),
};
const upgrade = lazy(() => import('views/upgrade/Upgrade'));

const dashboard = {
  gettingStarted: lazy(() => import('views/dashboard/DashboardGettingStarted')),
  analysis: lazy(() => import('views/dashboard/DashboardAnalysis')),
};
const learning = {
  classes: lazy(() => import('views/learning/Classes')),
  standards: lazy(() => import('views/learning/Standards')),
  lessonParts: lazy(() => import('views/learning/LessonParts')),
};
const utilities = {
  series: lazy(() => import('views/utilities/Series')),
  standard: lazy(() => import('views/utilities/Standard')),
  subject: lazy(() => import('views/utilities/Subject')),
  lesson: lazy(() => import('views/utilities/Lesson')),
  assessment: lazy(() => import('views/utilities/Assessment')),
  examLessons: lazy(() => import('views/utilities/tables/assessment/examLessions')),
  examStandards: lazy(() => import('views/utilities/tables/assessment/examStandards')),
  examSubjects: lazy(() => import('views/utilities/tables/assessment/examSubjects')),
  exam : lazy(()=>import('views/utilities/Exam')),
  assessmentLessons: lazy(() => import('views/utilities/tables/assessment/assessmentLessions')),
  assessmentStandards: lazy(() => import('views/utilities/tables/assessment/assessmentStandards')),
  assessmentSubjects: lazy(() => import('views/utilities/tables/assessment/assessmentSubjects')),
  homework : lazy(()=>import('views/utilities/homework')),
  subjects : lazy(()=>import('views/utilities/tables/homework/homeworkSubjects')),
  homeworkStandards : lazy(()=>import('views/utilities/tables/homework/homeworkStandards')),
  homeworkLessons : lazy(()=>import('views/utilities/tables/homework/homeworkLessons')),
  dayPlanSubjects : lazy(()=>import('views/utilities/tables/dayPlan/dayPlanSubjects')),
  dayPlanStandards : lazy(()=>import('views/utilities/tables/dayPlan/dayPlanStandards')),
  dayPlanLessons : lazy(()=>import('views/utilities/tables/dayPlan/dayPlanLessions')),
  dayPlan : lazy(()=>import('views/utilities/dayPlan')),
  alert : lazy(()=>import('views/utilities/Alerts')),
  LearningSubjects : lazy(()=>import('views/utilities/tables/learningResource/learningSubjects')),
  LearningStandards : lazy(()=>import('views/utilities/tables/learningResource/learningStandards')),
  LearningLessons : lazy(()=>import('views/utilities/tables/learningResource/learningLessions')),
  LearningResource : lazy(()=>import('views/utilities/tables/learningResource/ElearningDashboard')),
  ExamsViewComponent : lazy(()=>import('views/utilities/tables/learningResource/examOrAssessmentViewResult')),
  Dashboard : lazy(()=>import('views/utilities/tables/dashboard/dashboard')),
  EbookStandards : lazy(()=>import('views/utilities/tables/E-book/ebookStandards')),
  EbookSubjects : lazy(()=>import('views/utilities/tables/E-book/ebookSubjects')),
  Ebooks : lazy(()=>import('views/utilities/tables/E-book/ebook')),
  EbookSeries : lazy(()=>import('views/utilities/tables/E-book/ebookSeries')),
  OnlineTainingSeries : lazy(()=>import('views/utilities/tables/onlineTraining/onlineSeries')),
  onlinetrainingStandards : lazy(()=>import('views/utilities/tables/onlineTraining/onlineStandards')),
  OnlineTrainingSubjects : lazy(()=>import('views/utilities/tables/onlineTraining/onlineSubjects')),
  OnlineTraining : lazy(()=>import('views/utilities/tables/onlineTraining/onlineTraining')),
  TeacherResourceStandards : lazy(()=>import('views/utilities/tables/teacherResource/teacherStandards')),
  TeacherResourceSeries : lazy(()=>import('views/utilities/tables/teacherResource/teacherSeries')),
  TeacherResource : lazy(()=>import('views/utilities/tables/teacherResource/teacherResource')),
  PracticeStandards : lazy(()=>import('views/utilities/tables/preparation/preparationStandards')),
  PracticeSubjects : lazy(()=>import('views/utilities/tables/preparation/preparationSubjects')),
  Practice : lazy(()=>import('views/utilities/tables/preparation/preparation')),
  PracticeSeries : lazy(()=>import('views/utilities/tables/preparation/preparationSeries')),
  ViewDayPlanImages : lazy(()=>import('views/utilities/showImages')),
  timeTable: lazy(() => import('views/utilities/TimeTable')),
  TeacherAi : lazy(()=>import('views/utilities/tables/learningResource/StudentAI')),
};
const school_services = {
  distributor: lazy(() => import('views/utilities/Distributor')),
  school: lazy(() => import('views/utilities/School')),
  section: lazy(() => import('views/utilities/Section')),
  student: lazy(() => import('views/utilities/Student')),
  teacher : lazy(() => import('views/utilities/TeacherNew')),
  SchoolDashboard : lazy(() => import('dashboard/school_dashboard.js')),

  // AssignSubjectsToSections : lazy(() => import('views/utilities/assignSubjectsToSections.js'))
};
const teacher_services = {
  tattendance: lazy(() => import('views/utilities/TAttendance')),
  studentAtttendenceTable : lazy(() => import('views/utilities/tables/tattendance/TAttendanceTable')),
  studentReports : lazy(() => import('views/utilities/studentReports')),
  studentLessons: lazy(() => import('views/utilities/tables/student/studentLessions')),
  studentStandards: lazy(() => import('views/utilities/tables/student/studentStandards')),
  studentSubjects: lazy(() => import('views/utilities/tables/student/studentSubjects')),
};
const student_services = {
  classes: lazy(() => import('views/utilities/StClasses')),
  standards: lazy(() => import('views/utilities/tables/stclasses/Standards')),
  lessonParts: lazy(() => import('views/utilities/tables/stclasses/LessonParts')),
};
const services = {
  database: lazy(() => import('views/services/ServicesDatabase')),
  databaseAdd: lazy(() => import('views/services/ServicesDatabaseAdd')),
  databaseDetail: lazy(() => import('views/services/ServicesDatabaseDetail')),
  storage: lazy(() => import('views/services/ServicesStorage')),
  storageFolder: lazy(() => import('views/services/ServicesStorageFolder')),
  hosting: lazy(() => import('views/services/ServicesHosting')),
  users: lazy(() => import('views/services/ServicesUsers')),
};
const account = {
  settings: lazy(() => import('views/account/AccountSettings')),
  billing: lazy(() => import('views/account/AccountBilling')),
  security: lazy(() => import('views/account/AccountSecurity')),
};
const support = {
  docs: lazy(() => import('views/support/SupportDocs')),
  docsDetail: lazy(() => import('views/support/SupportDocsDetail')),
  knowledgeBase: lazy(() => import('views/support/SupportKnowledgeBase')),
  tickets: lazy(() => import('views/support/SupportTickets')),
  ticketsDetail: lazy(() => import('views/support/SupportTicketsDetail')),
};
const doubts = {
  doubts :lazy(()=>import('views/utilities/tables/doubts/doubts')),
}

const IframeViewer = {
   IframeViewer :lazy(()=>import('views/utilities/commonComponentForIframe')),
}
const appRoot = DEFAULT_PATHS.APP.endsWith('/')
  ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length)
  : DEFAULT_PATHS.APP;

const routesAndMenuItems = {
  mainMenuItems: [
    {
      path: DEFAULT_PATHS.APP,
      exact: true,
      redirect: true,
      to: `${appRoot}/utilities/dashboard`,
    },
    // {
    //   path: `${appRoot}/learning`,
    //   exact: true,
    //   redirect: true,
    //   label: 'menu.learning',
    //   icon: 'online-class',
    //   component: learning.classes,
    // },
  ],
  sidebarItems: [
    // {
    //   path: `${appRoot}/learning`,
    //   label: 'menu.learning',
    //   icon: 'grid-1',
    //   exact: true,
    //   redirect: true,
    //   to: `${appRoot}/learning/classes`,
    //   subs: [
    //     {
    //       path: '/classes',
    //       label: 'menu.classes',
    //       icon: 'online-class',
    //       component: learning.classes,
    //     },
    //     {
    //       path: '/standards',
    //       label: 'menu.standards',
    //       hideInMenu: true,
    //       component: learning.standards,
    //     },
    //     {
    //       path: '/parts',
    //       label: 'menu.parts',
    //       hideInMenu: true,
    //       component: learning.lessonParts,
    //     },
    //   ],
    // },
    {
      path: `${appRoot}/utilities`,
      // label: 'menu.utilities',
      icon: 'grid-1',
      exact: true,
      redirect: true,
      to: `${appRoot}/utilities/assessment`,
      subs: [
        // {
        //   path: '/series',
        //   label: 'menu.series',
        //   icon: 'list',
        //   component: utilities.series,
        // },
        // {
        //   path: '/standard',
        //   label: 'menu.standard',
        //   icon: 'abacus',
        //   component: utilities.standard,
        // },
        // {
        //   path: '/subject',
        //   label: 'menu.subject',
        //   icon: 'book-open',
        //   component: utilities.subject,
        // },
        // {
        //   path: '/lesson',
        //   label: 'menu.lesson',
        //   icon: 'science',
        //   component: utilities.lesson,
        // },
        {
          path: '/assessment',
          // label: 'menu.assessment',
          icon: 'quiz',
          component: utilities.assessmentStandards,
        },
        {
          path: '/dashboard',
          // label: 'menu.assessment',
          // icon: 'quiz',
          component: utilities.Dashboard,
        },
        {
          path: '/exam',
          // label: 'menu.exam',
          icon: 'server',
          component: utilities.examStandards,
        },
        // {
        //   path: '/homework',
        //   label: 'menu.homework',
        //   icon: 'quiz',
        //   component: utilities.homework,
        // },
         {
          path: '/subjects',
          // label: 'menu.homework',
          icon: 'book',
          component: utilities.homeworkStandards,
        },
        {
          path: '/day_plan_standards',
          // label: 'menu.dayPlan',
          icon: 'folders',
          component: utilities.dayPlanStandards,
        },
        {
          path: '/alert',
          // label: 'menu.alert',
          icon: 'bell',
          component: utilities.alert,
        },
        {
          path: '/lesson_resource_standards',
          // label: 'menu.learningResource',
          icon: 'electricity',
          component: utilities.LearningStandards,
        },
        {
          path: '/comingSoon',
          // label: 'menu.exam',
          icon: 'server',
          component: ComingSoon,
        },
          {
          path: '/coming-soon/:module',
          component: ComingSoonModule,
        },
        // {
        //   path: '/distributor',
        //   label: 'menu.distributor',
        //   icon: 'diagram-1',
        //   component: school_services.distributor,
        // },
        // {
        //   path: '/school',
        //   label: 'menu.school',
        //   icon: 'diploma',
        //   component: school_services.school,
        // },
        {
          path: '/Ebook-series',
          component: utilities.EbookSeries,
        },
        {
          path: '/Ebook-standards',
          component: utilities.EbookStandards,
        },
        {
          path: '/Ebook-subjects',
          component: utilities.EbookSubjects,
        },
        {
          path: '/E-Books',
          component: utilities.Ebooks,
        },
        {
          path: '/online-series',
          component: utilities.OnlineTainingSeries,
        },
        {
          path: '/online-standards',
          component: utilities.onlinetrainingStandards,
        },
        {
          path: '/online-subjects',
          component: utilities.OnlineTrainingSubjects,
        },
        {
          path: '/online-training',
          component: utilities.OnlineTraining,
        },
        {
          path: '/teacher-resource-series',
          component: utilities.TeacherResourceSeries,
        },
        {
          path: '/teacher-resource-standards',
          component: utilities.TeacherResourceStandards,
        },
        {
          path: '/teacher-resource',
          component: utilities.TeacherResource,
        },
        {
          path: '/practice-series',
          component: utilities.PracticeSeries,
        },
        {
          path: '/practice-standards',
          component: utilities.PracticeStandards,
        },
        {
          path: '/practice-subjects',
          component: utilities.PracticeSubjects,
        },
        {
          path: '/Practice',
          component: utilities.Practice,
        },
        {
          path: '/doubts',
          // label: 'menu.exam',
          // icon: 'server',
          component: doubts.doubts,
        },
        {
          path: '/teacher-ai',
          component: utilities.TeacherAi,
        },

      ],
    },
    {
      path: `${appRoot}/school_services`,
      // label: 'menu.school_services',
      icon: 'grid-1',
      exact: true,
      redirect: true,
      to: `${appRoot}/school_services/distributor`,
      subs: [
        // {
        //   path: '/section',
        //   label: 'menu.section',
        //   icon: 'tag',
        //   component: school_services.section,
        // },
        {
          path: '/teacher',
          // label: 'menu.teacher',
          icon: 'board-1',
          component: school_services.teacher,
        },
      ],
    },
    {
      path: `${appRoot}/teacher_services`,
      // label: 'menu.teacher_services',
      icon: 'grid-1',
      exact: true,
      redirect: true,
      to: `${appRoot}/teacher_services/tattendance`,
      subs: [
        {
          path: '/tattendance',
          // label: 'menu.tattendance',
          icon: 'chart-3',
          component: teacher_services.tattendance,
        },
        {
          path: '/student',
          // label: 'menu.student',
          icon: 'user',
          component: teacher_services.studentStandards,
        },
        {
          path: '/reports',
          // label: 'menu.reports',
          icon: 'layout-1',
          component: teacher_services.studentReports,
        },
      ],
    },
    {
      path: `${appRoot}/assessment`,
      // icon: 'home-garage',
      // label: 'menu.dashboards',
      exact: true,
      redirect: true,
      to: `${appRoot}/assessment/quesions/:id`,
      subs: [
        { path: '/quesions/:id', label: 'menu.quesions', component: assessmentQuestions.questions },
        // { path: '/school', label: 'menu.school', component: dashboards.school },
      ],
    },
    // {
    //   path: `${appRoot}/student_services`,
    //   label: 'menu.student_services',
    //   icon: 'grid-1',
    //   exact: true,
    //   redirect: true,
    //   to: `${appRoot}/student_services/classes`,
    //   subs: [
    //     {
    //       path: '/classes',
    //       label: 'menu.classes',
    //       icon: 'online-class',
    //       component: student_services.classes,
    //     },
    //     {
    //       path: '/standards',
    //       label: 'menu.standards',
    //       hideInMenu: true,
    //       component: student_services.standards,
    //     },
    //     {
    //       path: '/parts',
    //       label: 'menu.parts',
    //       hideInMenu: true,
    //       component: student_services.lessonParts,
    //     },
    //   ],
    // },
    // {
    //   path: `${appRoot}/services`,
    //   label: 'menu.services',
    //   icon: 'grid-1',
    //   exact: true,
    //   redirect: true,
    //   to: `${appRoot}/services/database`,
    //   subs: [
    //     {
    //       path: '/database',
    //       label: 'menu.database',
    //       icon: 'database',
    //       component: services.database,
    //       subs: [
    //         {
    //           path: '/add',
    //           label: 'menu.database-add',
    //           hideInMenu: true,
    //           component: services.databaseAdd,
    //         },
    //         {
    //           path: '/detail',
    //           label: 'menu.database-detail',
    //           hideInMenu: true,
    //           component: services.databaseDetail,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/storage',
    //       label: 'menu.storage',
    //       icon: 'file-image',
    //       component: services.storage,
    //       subs: [
    //         {
    //           path: '/folder',
    //           label: 'menu.storage',
    //           hideInMenu: true,
    //           component: services.storageFolder,
    //         },
    //       ],
    //     },
    //     { path: '/storage-folder', component: services.storageFolder, hideInMenu: true },
    //     { path: '/hosting', label: 'menu.hosting', icon: 'router', component: services.hosting },
    //     { path: '/users', label: 'menu.users', icon: 'user', component: services.users },
    //   ],
    // },
    // {
    //   path: `${appRoot}/account`,
    //   label: 'menu.account',
    //   icon: 'user',
    //   exact: true,
    //   redirect: true,
    //   to: `${appRoot}/account/settings`,
    //   subs: [
    //     { path: '/settings', label: 'menu.settings', icon: 'gear', component: account.settings },
    //     {
    //       path: '/billing',
    //       label: 'menu.billing',
    //       icon: 'credit-card',
    //       component: account.billing,
    //     },
    //     { path: '/security', label: 'menu.security', icon: 'shield', component: account.security },
    //   ],
    // },
    // {
    //   path: `${appRoot}/support`,
    //   label: 'menu.support',
    //   icon: 'help',
    //   exact: true,
    //   redirect: true,
    //   to: `${appRoot}/support/docs`,
    //   subs: [
    //     {
    //       path: '/docs',
    //       label: 'menu.docs',
    //       icon: 'file-empty',
    //       component: support.docs,
    //       subs: [
    //         {
    //           path: '/detail',
    //           label: 'menu.docs',
    //           icon: 'file-empty',
    //           component: support.docsDetail,
    //           hideInMenu: true,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/knowledge-base',
    //       label: 'menu.knowledge-base',
    //       icon: 'notebook-1',
    //       component: support.knowledgeBase,
    //     },
    //     {
    //       path: '/tickets',
    //       label: 'menu.tickets',
    //       icon: 'bookmark',
    //       component: support.tickets,
    //       subs: [
    //         {
    //           path: '/detail',
    //           label: 'menu.tickets-detail',
    //           icon: 'file-empty',
    //           component: support.ticketsDetail,
    //           hideInMenu: true,
    //         },
    //       ],
    //     },
    //   ],
    // },
    {
          path: '/homework',
          // label: 'menu.homework',
          // icon: 'quiz',
          component: utilities.homework,
        },
        {
          path: '/day_plan',
          // label: 'menu.dayPlan',
          // icon: 'quiz',
          component:DayPlan,
        },
        {
          path: '/day_plan_subjects',
          // label: 'menu.dayPlan',
          // icon: 'quiz',
          component:utilities.dayPlanSubjects,
        },
        {
          path: '/day_plan_lessions',
          // label: 'menu.dayPlan',
          // icon: 'quiz',
          component:utilities.dayPlanLessons,
        },

        {
          path: '/alerts',
          // label: 'menu.alerts',
          // icon: 'quiz',
          component:Alert,
        },
        
        {
          path: '/attendance_submit_form',
          // label: 'menu.homework',
          // icon: 'quiz',
          component: teacher_services.studentAtttendenceTable,
        },
        {
          path: '/learning_resource_subjects',
          // label: 'menu.dayPlan',
          // icon: 'quiz',
          component:utilities.LearningSubjects,
        },
        {
          path: '/learning_resource_lessons',
          // label: 'menu.dayPlan',
          // icon: 'quiz',
          component:utilities.LearningLessons,
        },
        {
          path: '/elearning',
          // label: 'menu.dayPlan',
          // icon: 'quiz',
          component:utilities.LearningResource,
        },
        {
          path: "/viewResults",
          // exact: true,
          component: utilities.ExamsViewComponent,  
        },
        {
          path: "/subject/assessment",
          // exact: true,
          component: AssessmentComponent, // Assuming "exams.exam" is actually "Exam"
        },
        {
          path: '/assessments',
          component: utilities.assessment,
        },
        {
          path: '/assessment_subjects',
          component: utilities.assessmentSubjects,
        },
        {
          path: '/assessment_lessons',
          component: utilities.assessmentLessons,
        },
        {
          path: '/exams',
          component: utilities.exam,
        },
        {
          path: '/exam_subjects',
          component: utilities.examSubjects,
        },
        {
          path: '/exam_lessons',
          component: utilities.examLessons,
        },
        {
          path: '/students',
          component: school_services.student,
        },
        {
          path: '/student_subjects',
          component: teacher_services.studentSubjects,
        },
        {
          path: '/student_lessons',
          component: teacher_services.studentLessons,
        },
        {
          path: '/homework_subjects',
          component: utilities.subjects,
        },
        {
          path: '/homework_lessons',
          component: utilities.homeworkLessons,
        },
         {
          path: '/view-content',
          component: IframeViewer.IframeViewer,
        },
        {
          path: '/view-plan-images',
          component: utilities.ViewDayPlanImages,
        },
        // {
        //   path: '/assign-subjects-to-sections',
        //   component: school_services.AssignSubjectsToSections,
        // }
        {
          path: '/school_dashboard',
          component: school_services.SchoolDashboard,
        },
        {
          path: '/timetable',
          component: utilities.timeTable,
        }
       
        
  ],
};
export default routesAndMenuItems;
